import type { companies as en } from '@/i18n/locales/en/companies';
import type { Translation } from '@/i18n/types';

export const companies: Translation<typeof en> = {
  list: {
    title: 'Aziende',
    newCompany: 'Nuova azienda',
    empty: 'Nessuna azienda visibile a te.',
    name: 'Nome',
    created: 'Creata',
    rowsLabel: 'le aziende',
    healthTitle: 'Salute dell’organizzazione',
    healthCompanies: 'Aziende',
    healthEditions: 'Edizioni',
    healthPilots: 'Pilot',
    healthPilotsLabel: 'il riepilogo dei pilot',
    healthActivePilotCount: '{{count}} aziende con un pilot attivo',
  },
  detail: {
    thisCompany: 'azienda',
    rename: 'Rinomina',
    companyAdmins: 'Amministratori dell’azienda',
    delete: 'Elimina',
    departmentsTitle: 'Reparti',
    newDepartment: 'Nuovo reparto',
    departmentsEmpty: 'Ancora nessun reparto.',
    departmentsLabel: 'i reparti',
    name: 'Nome',
    statistics: 'Statistiche',
    collectiveConsent: 'Consenso collettivo',
    inForce: 'in vigore',
    settingsTitle: 'Impostazioni',
    settingsLabel: 'le impostazioni',
    change: 'Modifica',
    minGroupSizeLabel: 'Dimensione minima del gruppo per gli aggregati:',
    systemDefault: 'valore predefinito di sistema',
    companyOverride: 'valore specifico dell’azienda',
    domainsTitle: 'Domini e-mail',
    domainsLabel: 'i domini',
    manage: 'Gestisci',
    domainsEmpty: 'Nessun dominio registrato.',
    membersTitle: 'Membri',
    membersLabel: 'i membri',
    addPerson: 'Aggiungi persona',
    membersEmpty: 'Nessun membro.',
    email: 'E-mail',
    login: 'Accesso',
    source: 'Origine',
    actions: 'Azioni',
    yes: 'sì',
    no: 'no',
  },
  form: {
    newTitle: 'Nuova azienda',
    name: 'Nome',
    cancel: 'Annulla',
    create: 'Crea azienda',
    editTitle: 'Rinomina azienda',
    save: 'Salva',
    deleteTitle: 'Elimina azienda',
    deleteLead:
      'Eliminando {{name}} terminano anche i suoi domini e le righe di appartenenza. Questa azione non può essere annullata. Digita il nome dell’azienda per confermare.',
    companyNameLabel: 'Nome azienda',
    deletePermanently: 'Elimina definitivamente',
    settingsTitle: 'Soglia di aggregazione',
    settingsLead:
      'La dimensione minima del gruppo al di sotto della quale gli aggregati non vengono mostrati. Lascia vuoto per tornare al valore predefinito di sistema. L’API applica un limite minimo assoluto.',
    minGroupSize: 'Dimensione minima del gruppo',
    domainsTitle: 'Domini e-mail',
    domainsLead:
      'Un indirizzo verificato su uno di questi domini iscrive il suo titolare in questa azienda al momento dell’accesso. Le appartenenze esistenti restano quando un dominio viene rimosso.',
    remove: 'Rimuovi',
    addDomain: 'Aggiungi dominio',
    add: 'Aggiungi',
    backToCompany: 'Torna all’azienda',
  },
  health: {
    title: 'Salute dell’organizzazione',
    edition: 'Edizione',
    editionFit: 'Fit',
    editionSoccer: 'Soccer',
    members: 'Membri',
    pilotsTitle: 'Pilot',
    pilotsLabel: 'lo stato dei pilot',
    noPilots: 'Ancora nessun pilot.',
    activeCount: '{{count}} attivi',
    scaledCount: '{{count}} scalati',
    totalCount: '{{count}} totali',
    viewAllPilots: 'Vedi tutti i pilot',
  },
};
